module.exports = __webpack_public_path__ + "img/badge-list-thumb-040.82586807.png";